import React, { ReactNode, useEffect, useRef } from "react";
import { useAuth } from "../../context/AuthContext";
import { Navigate } from "react-router-dom";
import Navigation from "../../components/navBar/navBarAuth/navBarAuth";
export const LayoutAuth = ({ children }) => {
  const { isAuth } = useAuth();
  return isAuth ? (
    <>
      <Navigation />
      <div>{children}</div>
    </>
  ) : (
    <Navigate to="/" />
  );
};
